// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pwnM","controls":"styles_controls__3NhB1","charLimit":"styles_charLimit__tglV2","input":"styles_input__1XWeg","send":"styles_send__12IES"};